import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { DEFAULT_KIND, DEFAULT_THEME, DEFAULT_TYPE, DEFAULT_SIZE } from './config';
import type { TButtonComponent } from './models';

export const Button: FC<React.PropsWithChildren<TButtonComponent>> = ({
    children,
    className,
    dataTestId = 'button',
    disabled,
    iconUrl,
    kind = DEFAULT_KIND,
    size = DEFAULT_SIZE,
    styles,
    theme = DEFAULT_THEME,
    type = DEFAULT_TYPE,
    width,
    ...rest
}) => {
    const sizeStyles = styles[`${size}Size`];
    const widthStyles = width ? styles[`width-${width}`] : null;

    const classNames = cn(
        styles.button,
        styles[`${kind}Kind`],
        styles[`${theme}Theme`],
        sizeStyles,
        widthStyles,
        className
    );

    return (
        <button
            className={classNames}
            data-test-id={dataTestId}
            disabled={disabled}
            type={type}
            {...rest}
        >
            {iconUrl && (
                <span
                    className={cn(styles.icon, sizeStyles)}
                    style={{ backgroundImage: `url(${iconUrl})` }}
                />
            )}
            {children}
        </button>
    );
};
